<mat-accordion class="example-headers-align w-full min-w-0 max-w-full block box-border" multi>
  @for (section of route.sections; track section; let sectionIndex = $index) {
    @switch (section.type) {
      @case (sectionTypes.PEDESTRIAN) {
        <app-detailed-result-route-pedestrian [index]="sectionIndex"
          [section]="section" [formValues]="formValues" [length]="route.sections.length" (focusLocationEvent)="focusLocation($event)" [leg]="leg" [isNextSectionCar]="isNextSectionCarAfterWalk(section, sectionIndex)" [isWalkingToStop]="isWalkingToStop(section, sectionIndex)"
          [style.--prev-section-color]="sectionIndex > 0 ? getSectionColor(route.sections[sectionIndex - 1].type) : 'transparent'"/>
      }
      @case (sectionTypes.TRANSIT) {
        <app-detailed-result-route-transit [index]="sectionIndex" [section]="section"
          [length]="route.sections.length" (focusLocationEvent)="focusLocation($event)" [isWalkedToStop]="isWalkedToStop(section, sectionIndex)"
          [style.--prev-section-color]="sectionIndex > 0 ? getSectionColor(route.sections[sectionIndex - 1].type) : 'transparent'" [prevSection]="route.sections[sectionIndex - 1]"/>
      }
      @case (sectionTypes.VEHICLE) {
        <app-detailed-result-route-vehicle [index]="sectionIndex" [section]="section"
          [length]="route.sections.length" (focusLocationEvent)="focusLocation($event)"
          [style.--prev-section-color]="sectionIndex > 0 ? getSectionColor(route.sections[sectionIndex - 1].type) : 'transparent'"/>
      }
    }
  }

  <app-detailed-result-route-destination [section]="route.sections[route.sections.length - 1]" (focusLocationEvent)="focusLocation($event)"
    [formValues]="formValues"
    [style.--prev-section-color]="getSectionColor(route.sections[route.sections.length - 1].type)" />
  </mat-accordion>
  @if (!!resizeService.isMobile) {
    <div class="sticky bottom-0 p-3 flex flex-col gap-4 z-50 bg-white">
      <mot-button
        buttonClass="not-disabled:!bg-primary w-full !text-white !py-6 !rounded-lg !align-middle disabled:!text-[#B4BFCB]"
        [text]="startRouteText" icon="location-arrow" [disabled]="!hasLocationPermissions" (onClick)="startTrackingRoute()"
        [matTooltip]="requiredLocationPermissionsText" matTooltipPosition="above"
        [matTooltipDisabled]="!!hasLocationPermissions" />
      </div>
    }